// extracted by mini-css-extract-plugin
export default {"w-full":"TooltipGlodal_w-full__dEG6J","tooltipWpapper":"TooltipGlodal_tooltipWpapper__m2Z-I"};